export const AUTH_HEADERS = {
  PUBTOOL_TOKEN: 'pubtool-token',
};

export const CAPTCHA_HEADERS = {
  CAPTCHA_TOKEN: 'H-CAPTCHA-RESPONSE',
};

export const KEYS_IN_REDIRECT_URL = [AUTH_HEADERS.PUBTOOL_TOKEN];
